var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"productsList",staticClass:"py-4 lg:py-6 xl:py-8 px-2 md:px-4 max-w-7xl mx-auto",class:{ isNoticeHead: !_vm.$store.state.isIndexTopNotice, mainBody: _vm.$store.state.isIndexTopMainBody }},[_c('div',{staticClass:"flex flex-wrap"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }